export const supportedFileFormats = [
  ".aac",
  ".Amr",
  ".bmp",
  ".csv",
  ".doc",
  ".docx",
  ".Gif",
  ".jpeg",
  ".jpg",
  ".m3u",
  ".m4a",
  ".MOV",
  ".mp3",
  ".mp4",
  ".msg",
  ".msword",
  ".ogg",
  ".pdf",
  ".png",
  ".ppt",
  ".pptx",
  ".rar",
  ".tif",
  ".tiff",
  ".wav",
  ".xls",
  ".xlsx",
  ".xps",
  ".zip",
  ".txt"
];

export const _noop = () => {}

export const DEFAULT_USER_DATA = {
    sourceId: null,
    customerId: null,
    customerFirstName: null,
    customerLastName: null,
    sourceType: 60,
    appId: null,
    clientChannel: null
}

export const MAIN_MENU_MESSAGE = {
  "Main Menu" : {
    "Hindi": "मुख्य मेन्यू",
    "Telugu": "ప్రధాన మెనూ",
    "Marathi": "मुख्य मेनू",
    "Gujarati": "મુખ્ય મેનુ",
    "Bengali": "প্রধান সূচি",
    "Kannada": "ಮುಖ್ಯ ಮೆನು",
    "Tamil": "முக்கிய மெனு",
    "Malayalam": "പ്രധാന മെനു",
    "Odia": "ମୁଖ୍ୟ ମେନୁ",
    "Punjabi": "ਮੁੱਖ ਮੀਨੂ",
    "Assamese": "মুখ্য মেনু",
    "English": "Main Menu"
  }
}
